import { render, staticRenderFns } from "./PackageType.vue?vue&type=template&id=6af72723&scoped=true"
import script from "./PackageType.vue?vue&type=script&lang=ts"
export * from "./PackageType.vue?vue&type=script&lang=ts"
import style0 from "./PackageType.vue?vue&type=style&index=0&id=6af72723&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af72723",
  null
  
)

export default component.exports